/*
 *   File : confirm.js
 *   Author : https://evoqins.com
 *   Description :Delete confirm modal
 *   Integrations : js-cookie
 *   Version : 1.0.0
*/

import { memo, useEffect } from 'react'

// Custom components
import { PrimaryButton, SecondaryButton } from '../Buttons';
import { Icon } from '../Icon';

const ConfirmationModal = (props) => {

    useEffect(() => {
        if (props.status === true) {
            _handleCloseModal();
        }
    }, [props.status]);

    // handle close Modal 
    const _handleCloseModal = () => {
        var button = document.getElementById("confirm-modal-close");
        button.click();
        props.handleClose();
    };


    // handle success
    const _handleSuccess = () => {
        props.handleSuccess();
    }

    return (
        <div className="modal fade" id="confirm-modal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="confirmDeleteModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered modal-md modal-dialog-scrollable">
                <div className="modal-content e-border-radius-12 w- mx-auto p-4 ">
                    <img src={require("../../Assets/Image/CountryAdmin/close-icon.svg").default}
                        draggable={false}
                        className='d-none'
                        id='confirm-modal-close'
                        alt='close'
                        data-bs-dismiss="modal" />

                    {props.type === 2 ?
                        <>
                            <div className="modal-header px-0 pt-0 pb-3 border-0 align-items-start justify-content-start">
                                <img src={props.icon}
                                    draggable={false}
                                    alt='bell' />
                            </div>
                            <div className="modal-body px-0 pt-1 pb-2">
                                <h4 className='mb-2 e-primary-font-playfair e-text-raisin-black e-font-18 e-font-weight-500 line-height-28px'>
                                    {props.title}
                                </h4>
                                <p className='mb-0 e-text-davys-grey e-alt-font-noto-sans e-font-14 e-font-weight-400 line-height-20px'>
                                    {props.description}
                                </p>
                            </div>

                            <div className='modal-footer border-0 p-0'>
                                <div className='row w-100 row-cols-2 pt-3'>
                                    <div className='col m-0 ps-0'>
                                        <SecondaryButton name="Cancel"
                                            className="w-100"
                                            onPress={_handleCloseModal} />
                                    </div>
                                    <div className='col m-0 pe-0'>
                                        <PrimaryButton name={props.primaryButtonLabel}
                                            className="w-100"
                                            status={props.loader}
                                            onPress={_handleSuccess} />
                                    </div>
                                </div>
                            </div>
                        </>
                        :   
                        <>
                            <div className="modal-header px-0 pt-0 pb-2 border-0 align-items-start justify-content-between">
                                <h4 className='mb-0 e-primary-font-playfair e-text-raisin-black e-font-18 e-font-weight-500 line-height-28px'>
                                    {props.title}
                                </h4>
                                <Icon icon="close-icon"
                                    className='cursor-pointer'
                                    size="24px"
                                    onPress={_handleCloseModal} />
                            </div>

                            <div className="modal-body px-0 pt-2 pb-2">
                                <p className='mb-0 e-text-davys-grey e-alt-font-noto-sans e-font-14 e-font-weight-400 line-height-20px'>
                                    {props.description}
                                </p>
                            </div>

                            <div className='modal-footer border-0 p-0'>
                                <div className='row w-100 row-cols-2 pt-3'>
                                    <div className='col m-0 ps-0'>
                                        <SecondaryButton name="Cancel"
                                            className="w-100"
                                            onPress={_handleCloseModal} />
                                    </div>
                                    <div className='col m-0 pe-0'>
                                        <PrimaryButton name={props.primaryButtonLabel}
                                            className="w-100"
                                            status={props.loader}
                                            onPress={_handleSuccess} />
                                    </div>
                                </div>
                            </div>
                        </>
                    }
                </div>
            </div>
        </div>

    )
}

ConfirmationModal.defaultProps = {
    delete: () => { },
    handleClose: () => { }
}


export default memo(ConfirmationModal);